import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/personalContact/findAll')
    return data
  },

  async findAllByPersonalData(body) {
    const { data } = await repository.post(baseURL + '/personalContact/findAllByPersonalData', body)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/personalContact', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/personalContact', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/personalContact/' + id)
  }
}
